import "../mohno-pump/mohno-man/scss/Foundation/mohno-man.scss";
import SimpleParallax from "simple-parallax-js/vanilla";
import { ModalListener } from "./modules/Modal/ModalListener";
import * as MODAL from "./modules/Modal/constants";

var image = document.getElementsByClassName("thumbnail");
new SimpleParallax(image, {
  delay: 1,
  orientation: "right up",
  scale: 1.5,
  overflow: false,
  transition: "cubic-bezier(0.33, 1, 0.68, 1)",
});

function init(this: Window) {
  /**
   * @type {HTMLCollectionOf<Element>} Modal triggers
   */
  const buttons: HTMLCollectionOf<Element> = document.getElementsByClassName(MODAL.CLASS_NAMES.BUTTON);
  for (let i = 0; i < buttons.length; i++) {
    const button: Element = buttons[i];
    if (button instanceof HTMLElement) {
      const listener = new ModalListener(button);
      listener.listen();
    } else break;
  }
}

window.addEventListener("load", init);
